<template lang="pug">
.expandable-list-item(:class="`${selected ? 'selected' : ''}`")
  .item-meta
    .content
      slot
    .dots-wrapper.ml-a.m-b-0(v-if="!!$slots.dots", :class="`${small ? 'p-x-4 p-t-1 p-b-1' : 'p-a-4'}`")
      Dots(ref="dots", :small="small" :class="dotsClass")
        slot(name="dots")
  .item-expand.p-x-4.p-b-4(v-if="!!$slots.expand")
    slot(name="expand")
</template>

<script>

import Dots from '@/components/Dots.vue';

export default {
  components: {
    Dots,
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      deafult: false,
    },
    dotsClass: {
      type: String,
      default: 'left',
    },
  },
};
</script>

<style lang="scss" scoped>
.expandable-list-item {
  align-items: center;
  display: flex;
  border-top: 1px solid #E7E9EC;
  flex-wrap: wrap;

  .item-meta {
    align-items: center;
    display: flex;
    width: 100%;

    .content {
      width: 100%;

      &:hover {
        cursor: pointer;
      }
    }

    .dots-wrapper {
      justify-content: flex-end;
      display: flex;
      line-height: 30px;
      order: 1;
      margin-bottom: auto;
    }
  }

  .item-expand {
    display: none;
    width: 100%;
  }

  &.selected {
    background-color: white;

    .item-expand {
      display: block;
    }
  }

  &:hover {
    background-color: white;
  }

  &:first-child {
    border-top: 0;

    &.selected, &:hover {
      border-radius: 10px 10px 0 0;
    }
  }

  &:last-child {
    &.selected, &:hover {
      border-radius: 0 0 10px 10px;
    }
  }

  &:only-child {
    &.selected, &:hover {
      border-radius: 10px;
    }
  }
}
</style>
